export function createFieldValidators(...args) {
  const syncRules = Array.isArray(args[0]) ? args[0] : args
  const asyncRules = Array.isArray(args[1]) ? args[1] : []

  return {
    onBlur: ({ value }) => {
      for (const rule of syncRules) {
        const result = rule(value)
        if (result) return result
      }

      return undefined
    },

    onBlurAsync: async ({ value }) => {
      for (const rule of asyncRules) {
        const result = await rule(value)
        if (result) return result
      }

      return undefined
    },

    onChange: ({ value, fieldApi }) => {
      // Do not show errors when user is typing
      if (fieldApi.state.meta.errors.length === 0) {
        return undefined
      }

      // Revalidate and show different error or hide error message if new field value is valid
      for (const rule of syncRules) {
        const result = rule(value)
        if (result) return result
      }

      return undefined
    },

    onChangeAsync: async ({ value, fieldApi }) => {
      // Do not show errors when user is typing
      if (fieldApi.state.meta.errors.length === 0) {
        return undefined
      }

      // Revalidate and show different error or hide error message if new field value is valid
      for (const rule of asyncRules) {
        const result = await rule(value)
        if (result) return result
      }

      fieldApi.setErrorMap({
        onBlur: undefined,
      })

      return undefined
    },
  }
}

export function checkIsEmailValid(email) {
  if (typeof email !== 'string') return false

  const [name, domain, ...rest] = email.split('@')
  if (!name || !domain) return false
  if (rest.length) return false

  if (!domain.includes('.')) return false

  return true
}

export function checkIsPhoneValid(phone) {
  if (typeof phone !== 'string') return false
  const matchResult = phone.match(/^(\+\d{1,3})? ?(\d{3}|\(\d{3}\)) ?\d{3}(-| )?\d{2}(-| )?\d{2}$/)
  return !!matchResult
}
